import { Routes } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy.component';

export const Privacy_Routes: Routes = [
  { path: '', component: PrivacyPolicyComponent },
];
